import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';

import { CampaignsIcon, Icon, NavItem } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

import SecondaryNav from '../SecondaryNav';
import HomeMarketingNav from './HomeMarketingNav';

import * as styles from './HomeNav.css';

function HomeNav(): JSX.Element | null {
  const { t } = useTranslation();
  const localUrl = useLocalUrl();
  const match = useRouteMatch<{ accountId: string; primary: string }>({
    path: '/:accountId/:primary',
  });

  if (!match) {
    return null;
  }

  return (
    <>
      <SecondaryNav className={styles.secondaryNav} label={'Home navigation'}>
        <NavItem
          className={classNames({ [styles.active]: match.params.primary === 'marketing' })}
          icon={<Icon icon={CampaignsIcon} />}
          to={localUrl('/marketing')}
        >
          {t('Marketing')}
        </NavItem>
        <NavItem>
          <HomeMarketingNav />
        </NavItem>
      </SecondaryNav>
    </>
  );
}

export default HomeNav;
